import styled from "styled-components";
export const SinglePageContainer = styled.div`
  padding-top: 30px !important;
  .back{
    padding: 16px 0;
    .icon{
      font-size: 36px;
    }
  }
  @media (max-width: 768px) {
    padding-top: 0 !important;
  }
`;
